'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _zhCN = require('iview/dist/locale/zh-CN');

var _zhCN2 = _interopRequireDefault(_zhCN);

var _enUS = require('iview/dist/locale/en-US');

var _enUS2 = _interopRequireDefault(_enUS);

var _frFR = require('iview/dist/locale/fr-FR');

var _frFR2 = _interopRequireDefault(_frFR);

var _esES = require('iview/dist/locale/es-ES');

var _esES2 = _interopRequireDefault(_esES);

var _ptPT = require('iview/dist/locale/pt-PT');

var _ptPT2 = _interopRequireDefault(_ptPT);

var _viVN = require('iview/dist/locale/vi-VN');

var _viVN2 = _interopRequireDefault(_viVN);

var _idID = require('iview/dist/locale/id-ID');

var _idID2 = _interopRequireDefault(_idID);

var _ruRU = require('iview/dist/locale/ru-RU');

var _ruRU2 = _interopRequireDefault(_ruRU);

var _tipsConf = require('@/config/tips-conf');

var _tipsConf2 = _interopRequireDefault(_tipsConf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  zh_CN: (0, _assign2.default)(_tipsConf2.default.zh_CN, _zhCN2.default),
  en_US: (0, _assign2.default)(_enUS2.default, _tipsConf2.default.en_US),
  fr_FR: (0, _assign2.default)(_frFR2.default, _tipsConf2.default.fr_FR),
  es_ES: (0, _assign2.default)(_esES2.default, _tipsConf2.default.es_ES),
  pt_PT: (0, _assign2.default)(_ptPT2.default, _tipsConf2.default.pt_PT),
  vi_VN: (0, _assign2.default)(_viVN2.default, _tipsConf2.default.vi_VN),
  id_ID: (0, _assign2.default)(_idID2.default, _tipsConf2.default.id_ID),
  ru_RU: (0, _assign2.default)(_ruRU2.default, _tipsConf2.default.ru_RU),
  kh_KH: _tipsConf2.default.kh_KH,
  laos_LA: _tipsConf2.default.laos_LA,
  ar_AR: _tipsConf2.default.ar_AR
};
// // 柬埔寨语
// import kh from 'iview/dist/locale/kh-KH'
// // 老挝语
// import laos from 'iview/dist/locale/laos-LA'
// // 阿拉伯语
// import ar from 'iview/dist/locale/ar-AR'